import { call, put } from 'redux-saga/effects';
import { createChartOfAccountsCustomRow } from '../api';
import {
  createChartOfAccountsCustomRowFailure,
  createChartOfAccountsCustomRowSuccess,
  fetchChartOfAccountsForOrganisationRequest,
} from '../actions';
import { CreateChartOfAccountsCustomRowRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, turnDrawerOff } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* createChartOfAccountsCustomRowSaga(
  action: CreateChartOfAccountsCustomRowRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, row } = action.payload;

    const response: ApiResponse = yield call(
      createChartOfAccountsCustomRow,
      organisationId,
      row
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(createChartOfAccountsCustomRowSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.custom-account-created-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh organisation chart of accounts so UI has the new row
    yield put(fetchChartOfAccountsForOrganisationRequest(organisationId));

    // Close the drawer after successful creation
    yield put(turnDrawerOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(createChartOfAccountsCustomRowFailure());
  }
}

